import WebRTCVideoPlayer from 'src/components/video/WebRTCVideoPlayer';

import type { Camera } from 'src/features/cameras/types/camera';

type Props = {
    camera: Camera;
};

export default function CameraPlayer(props: Props) {
    const { camera } = props;

    return <WebRTCVideoPlayer cameraId={camera.id} />;
}
